import { render } from "./TemplateCardAttachment.vue?vue&type=template&id=c7cfb7b4&scoped=true"
import script from "./TemplateCardAttachment.vue?vue&type=script&lang=js"
export * from "./TemplateCardAttachment.vue?vue&type=script&lang=js"

import "./TemplateCardAttachment.vue?vue&type=style&index=0&id=c7cfb7b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7cfb7b4"]])

export default __exports__